<template>
  <div class="swiper-container">
    <div class="swiper-wrapper">
      <div class="swiper-slide">
        <p style="font-size:25px; line-height: 25px">
          We want to make clinic management more easier than ever.
        </p>
      </div>
      <div class="swiper-slide">
        <p style="font-size:25px; line-height: 25px">
          We want to consume time and effort for doctors to calculate their profit.
        </p>
      </div>
      <div class="swiper-slide" style="padding-bottom: 50px !important">
        <p style="font-size:25px; line-height: 25px">
          Our concerns does not stop at this point our concerns continue to make all things in clinic management more eaiser and consuming doctors effort, time & money.
        </p>
      </div>
    </div>
    <!-- Add Pagination -->
    <div class="swiper-pagination" id="#paginator"></div>
  </div>
</template>

<script>
import Swiper from 'swiper/dist/js/swiper.js'
export default {
  mounted () {
    var swiper = new Swiper('.swiper-container', {
      spaceBetween: 30,
      centeredSlides: true,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      }
    })
  }
}
</script>

<style scoped>
html, body {
  position: relative;
  height: 100%;
}
body {
  font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
  margin: 0;
  padding: 0;
  height: 100%;
}
.swiper-container {
  width: 100%;
  height: 100%;
}
.swiper-slide {
  text-align: center;
  font-size: 18px;
  background: #fff;
  /* Center slide text vertically */
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  padding-bottom: 20px !important;
}
/*#paginator {
  margin-bottom: -10px !important;
}*/
</style>



// WEBPACK FOOTER //
// src/components/landing-page/start_page_components/Slider.vue